import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'

Vue.use(VueProgressBar, {
  color: 'whitesmoke',
  failedColor: '#ba1a22',
  thickness: '2px'
})
